<template>
    <div
        class="md-team layout7 mg-bg"
        :style="{
            ...spaceStyle,
            ...colorStyle
        }"
    >
        <div class="mg-container">
            <div class="module-header f-col">
                <site-title
                    :title="fmtTitle"
                />
                <div
                    class="arrow"
                    v-if="agents.length > useSlidesPerView && !isMobileSize"
                >
                    <i class="iconfont icon-arrow-up prev-el"></i>
                    <i class="split"></i>
                    <i class="iconfont icon-arrow-up next-el"></i>
                </div>
            </div>
            <swiper v-bind="options" v-if="agents.length" :class="'len-' + agents.length">
                <slide v-for="(agent, index) in agents" :key="index">
                    <AgentCard 
                        :agent="agent" 
                        :detailUrlTarget="detailUrlTarget" 
                        :theme="theme" 
                        :showCalendarLink="enableBookAppointment" 
                        :bookAppointmentProps="{ variant: 'arrow', btnColor }"
                    />
                </slide>
            </swiper>
        </div>
    </div>
</template>

<script>
import common from '../index-layout.js';
import { mapState } from 'pinia';
import { usePageStore } from '@/store';
import AgentCard from '../_components/agent-card-simple.vue';
import carousel from '../carousel';
export default {
    mixins: [common, carousel],
    components: {
        AgentCard
    },
    data: function() {
        return {
            imageStyle: {},
            containerStyle: {},
            slidesPerView: 2,
            mobileSlidesPerView: 1.1
        };
    },
    computed: {
        ...mapState(usePageStore, {
            company: store => store.companyInfo
        }),
        isMobile() {
            return this.platform.isMobile;
        }
    },
    methods: {}
};
</script>
<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.md-team.layout7 {
    line-height: 1.5;
    .agent {
        display: flex;
        row-gap: 20px;
        column-gap: 7.5%;
        @include media-600 {
            flex-direction: column;
        }
        @include media-min-600 {
            
            &:nth-of-type(2n + 1) {
                flex-direction: row-reverse;
            }
            &.reverse:nth-of-type(2n) {
                flex-direction: row-reverse;
            }
            &.reverse:nth-of-type(2n + 1) {
                flex-direction: row;
            }
        }
    }
    .agent + .agent {
        padding-top: 80px;
        @include media-600 {
            padding-top: 40px;
        }
    }
    .list-agent-card{
        width: 100%;
        .avatar-box-a{
            width: 100%;
            height: 450px;
            display: block;
            overflow: hidden;
            @include media-600 {
                height: 260px;
            }
            
        }
        .agent-info{
            .agent-name{
                font-family: var(--mg-title-font);
                font-size: 30px;
                color: var(--g-primary-color);
                margin-top: 30px;
                display: block;
                cursor: pointer;
                @include media-600 {
                    margin-top: 20px;
                    font-size: 24px;
                    line-height: 28px;
                }
            }
            .agent-position{
                font-size: 14px;
                color: var(--g-tip-color);
                margin-top: 6px;
            }
        }
    }
    .module-header{
        position: relative;
        margin-bottom: 30px;
        @include media-600 {
            margin-bottom: 20px;
        }
        .arrow{
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            color: var(--g-primary-color);
            .prev-el{
                font-size: 20px;
                display: inline-block;
                transform: rotate(-90deg);
            }
            .next-el{
                font-size: 20px;
                display: inline-block;
                transform: rotate(90deg);
            }
            .split{
                display: inline-block;
                width: 52px;
            }
        }
    }
    .swiper-wrapper{
        justify-content: space-between;
    }
    .len-1{
        .swiper-wrapper{
            justify-content: center;
        }
        // cover swiper inline style
        .swiper-slide{
            width: 50% !important;
            @include media-600 {
               width: 100% !important;
               margin-right: 0px !important;
            }
        }
    }
    .book-appointment{
        color: var(--g-text-color);
        background: transparent;
        font-size: 16px;
        margin-top: 20px;
        &:hover .text{
            text-decoration: underline;
        }
        .icon-arrow-up{
            transform: rotate(90deg) translateX(2px);
            margin-left: 5px;
        }
    }
    
}
</style>
